import React from "react";
import ProfileModule from "modules/profile";
import { FadeInt2Div } from "styledComponents/animation";

const Profile = () => {
  return (
    <>
      <FadeInt2Div>
        <ProfileModule />
      </FadeInt2Div>
    </>
  );
};

export default Profile;
